import { createContext, Dispatch, SetStateAction } from "react";
import { Page } from "referral-types";
import { KeyedMutator } from "swr";

type PageContextType = {
  page?: Page;
  mutator: KeyedMutator<Page>;
  refresh: () => void;

  isPageEditing?: boolean;
  setIsPageEditing: Dispatch<SetStateAction<boolean | undefined>>;
  toggleEditMode: () => void;
  isEditModeTransitionPending: boolean;
  isPagePreviewing?: boolean;
  setIsPagePreviewing: Dispatch<SetStateAction<boolean | undefined>>;
  togglePreviewMode: () => void;
  isPreviewModeTransitionPending: boolean;
  isPublishingPage?: boolean;
  setIsPublishingPage: Dispatch<SetStateAction<boolean | undefined>>;
  isUserEditing?: boolean;
  setIsUserEditing: Dispatch<SetStateAction<boolean | undefined>>;

  hasUnpublishedChanges?: boolean;
  hasUnpublishedPageChanges?: boolean;
  hasUnpublishedGroupListChanges?: boolean;
  hasUnpublishedGroupChanges?: boolean;
  hasUnpublishedReferralChanges?: boolean;
  setHasUnpublishedChanges: Dispatch<SetStateAction<boolean | undefined>>;
  setHasUnpublishedPageChanges: Dispatch<SetStateAction<boolean | undefined>>;
  setHasUnpublishedGroupListChanges: Dispatch<SetStateAction<boolean | undefined>>;
  setHasUnpublishedGroupChanges: Dispatch<SetStateAction<boolean | undefined>>;
  setHasUnpublishedReferralChanges: Dispatch<SetStateAction<boolean | undefined>>;

  isSavingChanges?: boolean;
  isSavingPageChanges?: boolean;
  isSavingGroupListChanges?: boolean;
  isSavingGroupChanges?: boolean;
  isSavingReferralChanges?: boolean;

  setIsSavingChanges: Dispatch<SetStateAction<boolean | undefined>>;
  setIsSavingPageChanges: Dispatch<SetStateAction<boolean | undefined>>;
  setIsSavingGroupListChanges: Dispatch<SetStateAction<boolean | undefined>>;
  setIsSavingGroupChanges: Dispatch<SetStateAction<boolean | undefined>>;
  setIsSavingReferralChanges: Dispatch<SetStateAction<boolean | undefined>>;

  groupInsertionPosition: number | null;
  setGroupInsertionPosition: (position: number | null) => void;
};

export const PageContext = createContext<PageContextType | undefined>(undefined);
